import { render, staticRenderFns } from "./Presidentunit.vue?vue&type=template&id=782a7c30&scoped=true"
import script from "./Presidentunit.vue?vue&type=script&lang=js"
export * from "./Presidentunit.vue?vue&type=script&lang=js"
import style0 from "./Presidentunit.vue?vue&type=style&index=0&id=782a7c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a7c30",
  null
  
)

export default component.exports